import { isEqual } from 'lodash-es'

export enum RxWebSocketReadyState {
  Connecting = 'Connecting',
  Errored = 'Errored',
  Open = 'Open',
  Closing = 'Closing',
  Closed = 'Closed'
}

interface RxWebSocketStatusBase {
  readyState: RxWebSocketReadyState
  endpoint: string
}

interface RxWebSocketStatusConnecting extends RxWebSocketStatusBase {
  readyState: RxWebSocketReadyState.Connecting
}

interface RxWebSocketStatusErrored extends RxWebSocketStatusBase {
  readyState: RxWebSocketReadyState.Errored
  error: Error
}

interface RxWebSocketStatusOpen extends RxWebSocketStatusBase {
  readyState: RxWebSocketReadyState.Open
}

interface RxWebSocketStatusClosing extends RxWebSocketStatusBase {
  readyState: RxWebSocketReadyState.Closing
}

interface RxWebSocketStatusClosed extends RxWebSocketStatusBase {
  readyState: RxWebSocketReadyState.Closed
  closeCode: number | null
  closeReason: string | null
}

export type RxWebSocketStatus =
  | RxWebSocketStatusConnecting
  | RxWebSocketStatusErrored
  | RxWebSocketStatusOpen
  | RxWebSocketStatusClosing
  | RxWebSocketStatusClosed

export const compareWebSocketStatus = (a: RxWebSocketStatus, b: RxWebSocketStatus) => isEqual(a, b)
